import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViewModeService {

  private isSupplierViewFlag: boolean;

  constructor(private activatedRoute: ActivatedRoute) {
    this.isSupplierViewFlag = this.determineViewMode();
  }

  private determineViewMode(): boolean {
    // Check query param for local testing
    const queryParams = new URLSearchParams(window.location.search);
    if (!environment.production && queryParams.get('viewSupplier') === 'true') {
      return false; // client view
    }

    const allowedUrls = environment.features?.allowedEmbeddingUrls as string[];
    if (allowedUrls?.length) {
      const ancestorOrigins = window.location.ancestorOrigins;
      if (ancestorOrigins && ancestorOrigins.length > 0) {
        const originsArray = Array.from(ancestorOrigins);
        if (originsArray.some(origin => allowedUrls.includes(origin))) {
          return false; 
        }
      }
    }

    const referrer = document.referrer;
    if (referrer) {
      let referrerOrigin;
      try { referrerOrigin = new URL(referrer).origin; } catch {}
      
      if (referrerOrigin && allowedUrls?.includes(referrerOrigin)) {
        return false;
      }
    }

    // Default to supplier view
    return true;
  }

  isSupplierView(): boolean {
    return !this.isSupplierViewFlag;
  }

  isClientView(): boolean {
    return this.isSupplierViewFlag;
  }
}